module.exports = __webpack_public_path__ + "img/payment.20052d53.png";